export default __webpack_public_path__ + "static/bluejay-0c9d622b5910cc07beae22080b85026a.svg";